/**
 * @ngdoc controller
 * @name RedeemController
 * @description Redeeming the gifted e-course.
 *
 * @constructor
 */
export default function RedeemController($state, RegistrationService, currentUser, ecourse, $scope) {
  'ngInject';

  this.formData = RegistrationService.formData;

  this.formData.redeem = {
    redemptionCode: $state.params.redemptionCode
  };

  this.ecourse = ecourse;

  this.countries = RegistrationService.countries;

  this.states = RegistrationService.states;

  this.generateScreenName = RegistrationService.generateScreenName;

  this.state = $state;

  this.formValid = () => {
    //if the forms arent ther, then they are valid!
    let userValid = this.userForm ? this.userForm.$valid : true,
      redeemValid = this.redeemForm ? this.redeemForm.$valid : true;
    if (userValid && redeemValid) {
      return true;
    }
    return false;
  };

  this.register = () => {
    if (this.formValid() && !this.loading) {
      this.loading = true;
      RegistrationService.register('redeem', ecourse, this).catch(
        (errors) => {
          this.loading = false;
          if (errors.userCreated) {
            this.userCreated = true;
          }
          this.registrationErrors = errors;
        }
      );
    }
  };
}



/** WEBPACK FOOTER **
 ** ./src/app/ecourse/registration/redeem/redeem.controller.js
 **/